import React from 'react';
import {Card, CardContent, CardHeader, Typography} from "@mui/material";
import BaseReportBox from "../BaseReportBox";

const _RCreditByGroup = () => {
    return (<>
            <BaseReportBox title={"میزان اعتبار تخصیص داده شده به هر گروه"} >


            </BaseReportBox>

        </>
    );
};

export default _RCreditByGroup;
